module.exports = __webpack_public_path__ + "static/media/LinkedIn.efd8dc2d.svg";